import { render, staticRenderFns } from "./FeedManagement.vue?vue&type=template&id=ef4dd2f2&"
import script from "./FeedManagement.vue?vue&type=script&lang=js&"
export * from "./FeedManagement.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports